import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import ReconciliationListing from './reconciliationlisting/ReconciliationListing';
import { componentKey } from './ReconciliationSlice';
import SubmitReconciliationListing from './submitreconciliation/SubmitReconciliationListing';

export default function Reconciliation() {
    useGarbageCollector(componentKey);
    
    return <>
        <Routes>
            <Route path="/listing" element={<ReconciliationListing />} />
            <Route path="/submitreconciliation" element={<SubmitReconciliationListing />} />
            <Route path="/*" element={<Navigate to={`/forms/reconciliation/listing`} replace={true} />} />
        </Routes>
    </>
}